import { IsArray, IsBoolean, IsDefined, IsNotEmpty, IsOptional, IsString, ValidateIf, isDefined, IsEnum, IsNumber, ValidateNested } from 'class-validator';

import { NomPosChildDataSource } from '../enum/nom-pos-child-data-source';
import { NomenclaturePositionChild } from '../nomenclature-position-child';

import { NomenclaturePositionChildOptionsUpdateRequest } from './nomenclature-position-child-options-update.request';

/**
 * One posted child of `NomenclaturePositionUpdateRequest.childPositions`.
 *
 * Identity mirrors PHP `NomenclaturePosition::importChildPositions` (:186-201): a posted child is
 * either an **existing row** of this position (the `uuid` leg) or a **candidate** of the position's
 * child types (the `nomTypeUuid` + `nomTypeChildName` leg) — never neither, and a payload may rely
 * on either one alone.
 */
export class NomenclaturePositionChildUpdateRequest implements NomenclaturePositionChild {
    @IsOptional()
    @IsString()
    @IsNotEmpty()
    public uuid?: string;

    @IsString()
    @IsNotEmpty()
    public nomTypeUuid: string;

    @IsString()
    @IsNotEmpty()
    public nomTypeChildName: string;

    @IsNumber()
    @IsEnum(NomPosChildDataSource)
    public dataSource: NomPosChildDataSource;

    @ValidateIf((o: NomenclaturePositionChildUpdateRequest) => isDefined(o.sourceUuid) || o.dataSource === NomPosChildDataSource.copyFrom)
    @IsDefined({ message: `sourceUuid should be specified when dataSource=${NomPosChildDataSource.copyFrom}` })
    @IsString()
    public sourceUuid?: string;

    @IsOptional()
    @IsString()
    public titleInOrder?: string;

    @IsBoolean()
    public requireInOrder: boolean;

    @IsArray()
    @ValidateNested({ each: true })
    public options: NomenclaturePositionChildOptionsUpdateRequest[];

    constructor(data?: Partial<NomenclaturePositionChildUpdateRequest>) {
        this.uuid = data?.uuid;
        this.nomTypeUuid = data?.nomTypeUuid;
        this.nomTypeChildName = data?.nomTypeChildName;
        this.dataSource = data?.dataSource;
        this.sourceUuid = data?.sourceUuid;
        this.titleInOrder = data?.titleInOrder;
        this.requireInOrder = data?.requireInOrder;
        this.options = NomenclaturePositionChildOptionsUpdateRequest.from(data?.options);
    }
}
